import { DefaultRequest } from 'scripts/api';

Greenmile.Survey = Greenmile.Survey || {};

Greenmile.Survey.ReportWindow = function () {

    this.el;
    this.selector = "#Survey";
    this.scopeBlock = "#Survey .form_and_grid_generic";
    this.options = {
        width: 600,
        height: 440
    };
    this.fieldsContainer = null;
    this.surveyId = null;

    this.monetMessage = new Monet.Form.Messages.InlineMessage();
    this.monetMessage.setScope("#Survey .popupFormContainer");
    this.monetMessage.setInfoType("error");

    this.renderGridContainer = function () {

        var container = document.createElement('div');
        var divGridActions = document.createElement('div');
        var divGridContainer = document.createElement('div');
        var monetUIGridActions = document.createElement("div");
        this.fieldsContainer = document.createElement("div");
        this.buttonsContainer = document.createElement("div");

        this.fieldsContainer.className = "ReportTemplateFields";
        this.buttonsContainer.className = "ReportTemplateButtons";
        monetUIGridActions.className = "MonetUIGridActions";
        container.className = 'MonetUIFormRelatedList';
        divGridActions.className = 'gridActions ui-widget-header';
        divGridContainer.className = 'gridContainer';

        container.appendChild(this.fieldsContainer);
        divGridActions.appendChild(monetUIGridActions);
        container.appendChild(divGridActions);
        container.appendChild(divGridContainer);
        container.appendChild(this.buttonsContainer);

        this.renderHeaderFields();
        this.renderFooterButtons();

        return container;
    };


    this.entity = "ReportTemplate";
    App.Forms[this.entity] = App.Forms[this.entity] || {};
    App.Forms[this.entity].layout = App.Forms[this.entity].layout || {};
    App.Forms[this.entity].layout.index = {
        "id": 10024,
        "userInterfaceAction": {
            "userInterface": {
                "id": 10008,
                "key": "Location",
                "description": "location.userinterface.description"
            },
            "key": "index"
        },
        "sections": [
            {
                "id": 9999999999,
                "pageLayout": {
                    "id": 999999999999
                },
                "key": "pls_index_grid_survey_report",
                "description": "survey.report.gridIndex",
                "layoutColumns": 1,
                "layoutOrder": 2,
                "sectionRelatedLists": [
                    {
                        "searchGridLayout": {
                            "id": 10008,
                            "entity": {
                                "key": "ReportTemplate"
                            },
                            "description": "survey_report.userinterface.description",
                            "kind": "DETAILED",
                            "searchGridColumns": [
                                {
                                    "searchGridLayout": {
                                        "id": 999999
                                    },
                                    "columnOrder": 1,
                                    "isSorted": false,
                                    "isAscendent": false,
                                    "sizePixels": 200,
                                    "field": {
                                        "id": 99999999,
                                        "name": "description",
                                        "label": "survey.reportTemplates.description",
                                        "type": "TEXT"
                                    }
                                },
                                {
                                    "searchGridLayout": {
                                        "id": 9999999
                                    },
                                    "columnOrder": 2,
                                    "isSorted": false,
                                    "isAscendent": false,
                                    "sizePixels": 200,
                                    "field": {
                                        "id": 999999999,
                                        "name": "originalFileName",
                                        "label": "survey.reportTemplates.originalFileName",
                                        "type": "TEXT"
                                    }
                                }
                            ],
                            "searchGridActions": [
                                {
                                    "pageLayoutSection": {
                                        "id": 10093
                                    },
                                    "buttonOrder": 1,
                                    "name": "btn_delete"
                                },
                                {
                                    "pageLayoutSection": {
                                        "id": 10093
                                    },
                                    "buttonOrder": 1,
                                    "name": "btn_edit"
                                }
                            ]
                        },
                        "pageLayoutSection": {
                            "id": 10093
                        },
                        "sectionOrder": 1
                    }
                ],
                "sectionFields": [],
                "sectionButtons": []
            }
        ]
    };
    App.Forms[this.entity].fields = {
        "intervalDate": {
            "id": 909090,
            "name": "intervalDate",
            "label": "survey.intervalDate",
            "translatedLabel": "Interval Date",
            "type": "DATE",
            "meta": null,
            "lookupEntity": null,
            "mandatory": false
        }
    };
    var optionsPagination = Monet.Grid.Utils.paginationOptions;
    App.Forms[this.entity].pagination = {};
    App.Forms[this.entity].pagination.first = optionsPagination.FIRST;
    App.Forms[this.entity].pagination.max = optionsPagination.MAX_RESULT;

    this.renderHeaderFields = function () {
        this.startDate = new Monet.UI.Fields.Render({
            "name": "startDate",
            "label": "Survey.Report.startDate",
            "description": "Survey.Report.startDate",
            "type": "DATE_TIME",
            "mandatory": true
        }).render();

        this.endDate = new Monet.UI.Fields.Render({
            "name": "endDate",
            "label": "Survey.Report.endDate",
            "description": "Survey.Report.endDate",
            "type": "DATE_TIME",
            "mandatory": true
        }).render();

        this.fieldsContainer.appendChild(this.startDate.rootEl);
        this.fieldsContainer.appendChild(this.endDate.rootEl);
    };

    this.newUploadFile = function () {
        var uploadModal = Greenmile.Survey.Modal.UploadModal;
        uploadModal.clear();

        var modal = new Greenmile.Survey.UploadWindow();
        modal.surveyId = this.surveyId;
        modal.showModalForm();
    }.bind(this);

    this.validateErrors = function (xhr) {

        /**
         * Get the application context for use in the fr.onload 
         * function that has its own context.
         */
        const scope = this;

        const fr = new FileReader();

        fr.onload = function() {

            // error receives response object
            const error = JSON.parse(this.result)

            scope.monetMessage.setMessage(error);
            scope.monetMessage.triggerMessage();
        };

        /**
         * FileReader is used here to transform the response object from blob to text and then to json. 
         * With this the error message can be applied to Monet Message.
         */
        fr.readAsText(xhr.response);
    };

    this.processResponse = (xhr) => {
        const a = document.createElement("a");
        const filename = JSON.parse(xhr.getResponseHeader("content-disposition").match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)[1]);
        a.style = "display: none";

        const url = URL.createObjectURL(xhr.response);

        a.href = url;
        a.download = filename;

        const ev = document.createEvent("MouseEvent");
        ev.initMouseEvent("click", true, true, window, null, 0, 0, 0, 0, false, false, false, false, 0, null);
        a.dispatchEvent(ev);
    };

    this.generateReport = function () {

        var startDate     = this.startDate,
            endDate       = this.endDate,
            allowToSubmit = {
                status: true,
                errorMessages: []
            },
            table         = App.Forms.ReportTemplate.table,
            selected      = table.getSelectedRows();

        var alert = document.querySelector("#ReportTemplate > div.monetInlineAlerContainer");
        alert.innerHTML = "";

        startDate.rootEl.className = startDate.rootEl.className.replace("control-group error", "");
        endDate.rootEl.className = endDate.rootEl.className.replace("control-group error", "");

        if (selected.length > 1) {
            allowToSubmit.status = false;
            allowToSubmit.errorMessages.push({
                message: "augusto.resource"
            });
        }

        var startValidate = startDate.validate(),
            endValidate   = endDate.validate();

        if (startValidate[0]) {
            allowToSubmit.status = false;
            allowToSubmit.errorMessages.push(startValidate[0]);
        }
        if (endValidate[0]) {
            allowToSubmit.status = false;
            allowToSubmit.errorMessages.push(endValidate[0]);
        }

        if (allowToSubmit.status) {
            this.handlerToggleBtns();
            var data = {
                start: startDate.getValue(),
                end: endDate.getValue(),
                surveyId: this.surveyId
            };

            var obj = table.getDataItem(selected[0]);

            if (obj) {
                data["templateId"] = obj.idOfObject;
            }

            var xhr = new XMLHttpRequest();
            xhr.responseType = "blob";

            xhr.addEventListener('readystatechange', (function (context) {
                return function () {
                    if (this.readyState === 4) {
                        if (this.status >= 400) { 
                            context.validateErrors(this);
                        } else {
                            context.processResponse(this);
                        }
                        context.handlerToggleBtns();
                    }
                };
            }(this)), false);
            xhr.open('POST', "Survey/Report");

            xhr.setRequestHeader('Content-Type', 'application/json');
            xhr.setRequestHeader("Cache-Control", "no-cache");
            xhr.setRequestHeader("Pragma", "no-cache");
            xhr.setRequestHeader("Greenmile-Module", "LIVE");

            xhr.send(JSON.stringify(data));

        } else {
            this.monetMessage.setMessage(allowToSubmit);
            this.monetMessage.triggerMessage();
        }

    }.bind(this);

    this.renderFooterButtons = function () {
        this.generateReportBtn = new Monet.UI.Fields.Render({
            "name": "btnGenerateReport",
            "label": "Survey.Report.Generate",
            "description": "btnGenerateReport",
            "type": "BUTTON",
            "mandatory": true
        }).render();

        this.uploadTemplateBtn = new Monet.UI.Fields.Render({
            "name": "uploadTemplate",
            "label": "Survey.uploadTemplate",
            "description": "uploadTemplate",
            "type": "BUTTON",
            "mandatory": true
        }).render();

        this.generateReportBtn.addEventClickListener(this.generateReport);
        this.uploadTemplateBtn.addEventClickListener(this.newUploadFile);

        this.buttonsContainer.appendChild(this.generateReportBtn.rootEl);
        this.buttonsContainer.appendChild(this.uploadTemplateBtn.rootEl);
    };

    this.renderEl = function () {
        var renderGrid = function () {

            var layoutIndex = App.Forms[this.entity].layout.index;
            var container = document.querySelector(this.selector + " .popupFormContainer");

            var alertError = document.createElement("div");

            var monetInlineAlerContainer = document.createElement("div");
            monetInlineAlerContainer.setAttribute("class", "monetInlineAlerContainer");

            monetInlineAlerContainer.appendChild(alertError);

            var div = document.createElement("div");

            div.id = this.entity;
            div.appendChild(monetInlineAlerContainer);
            div.appendChild(this.renderGridContainer());

            container.appendChild(div);

            var options = {
                entity: this.entity,
                columnCheckBox: {
                    show: true,
                    checkBoxEventClass: [Monet.Grid.ActionsModules.BatchDelete],
                    btnSelector: '#ReportTemplate .gridActions #buttonEventCheckBox',
                    options: {
                        checkOnClickRow: true
                    }
                },
                columnEdit: {
                    show: true
                },
                actions: [],
                gridActionsSelector: this.selector + " .popupFormContainer .gridActions",
                entityToActionGrid: this.entity,
                gridContainner: this.selector + " .popupFormContainer .gridContainer",
                headerMenu: {
                    headerMenuEventClass: Monet.Grid.ActionsModules.MenuShowTotals
                },
                multiColumnSort: true,
                multiSelect: false,
                frozenColumn: Monet.Grid.getIndexFrozenColumn(layoutIndex)
            };

            var columns = Monet.Grid.getGridLayout(layoutIndex, this.entity);

            var dataView = new Monet.Grid.DataProvider(columns, null, this.entity);
            var grid = new Monet.Grid.GenericGrid(options.gridContainner, dataView, columns, options);

            App.Forms[this.entity].table = grid;
            App.Forms[this.entity].dataProvider = dataView;


        }.bind(this);

        var checkDataMapperAndRenderGrid = function () {
            var dataMapper = new Monet.Builder.DataMapper();

            dataMapper.setEntity(this.entity);
            dataMapper.getFieldList = function (callback) {
                callback(App.Forms[this.entity].fields);
            };
            dataMapper.build(renderGrid);
            App.Objects[this.entity].updateGrid(null, null, null);
        }.bind(this);

        var layout = App.Forms[this.entity].layout.index;
        var pageLayout = new Monet.PageLayout();
        if (!layout) {
            pageLayout.getLayout(this.entity, 'index', checkDataMapperAndRenderGrid);
        } else {
            checkDataMapperAndRenderGrid();
        }

    };

    this.handlerToggleBtns = () => {
        const buttons = [this.generateReportBtn, this.uploadTemplateBtn];
        for(let i = 0; i < buttons.length; i++) {
            if(i < 1) {
                buttons[i].toggleLoadingInBtn();
            } else {
                buttons[i].rootEl.disabled = !buttons[i].rootEl.disabled;
            }
        }
    };

    if (!this.callbacks) {
        this.callbacks = {
            onAfterShowModalForm: this.renderEl.bind(this)
        };
    }


};

Greenmile.Survey.ReportWindow.prototype = new Monet.Form.Modal;
